<app-title-header [title]="'title.knowledge_library.title' | translate">
  <div class="actions-container">

    <app-global-search></app-global-search>

    <button type="button" class="create-btn" (click)="openCreateCasePopup()">
        <div>{{ 'buttons.create_new_case' | translate }} </div>
        <i class="bi bi-chevron-down"></i>
    </button>
  </div>
</app-title-header>

<app-dynamic-table
  *ngIf="isDataTableReady"
  [columns]="columns"
  [tableSizeClass]="'knowledge-library-page-table'"
  [rows]="cases"
  [useExternalApi]="true"
  [totalCount]="totalCount"
  [dataTableState]="casesDataTableState"
  [defaultColumns]="defaultColumns"
  [selectedFilterName]="selectedFilterName"
  [filters]="filters"
  [datatableDisplayAllNames]="datatableDisplayAllNames"
  [showColumnsSettingsBtn]="true"
  [showSaveDatatableFilterBtn]="true"
  [gridSettingsChanged]="!!casesDatatableStateFromStorage"
  (dataTableStateEvent)="getDataTableState($event)"
  (linkedValueClickEvent)="getLinkedValue($event)"
  (saveDataTableSettingsEvent)="onSaveDatatableSettings($event)"
  (updateDataTableSettingsEvent)="onUpdateDatatableSettings($event)"
></app-dynamic-table>

